import { useEffect, useState } from "react";

import { useAuth } from "../../../../../modules/auth";
import { useLazyReadQuery } from "../../../../services/data/tableDataApi";

export const useGatePassServiceId = () => {
    const { user, siteId } = useAuth();
    const [getRecord] = useLazyReadQuery();
    const [serviceId, setServiceId] = useState<string>();
    const [error, setError] = useState<string>();

    useEffect(() => {
        if (!user || !user.contactId || !siteId)
            return;

        getServiceIdAsync(user.userId, siteId, user.contactId)
            .then((serviceId) => setServiceId(serviceId))
            .catch((error) => setError(error.message));
        // eslint-disable-next-line
    }, [user]);

    const getServiceIdAsync = async (
        userId: string,
        siteId: string,
        contactId: string
    ): Promise<string> => {
        try {
            const contact = await getRecord({
                userId: userId,
                portalId: siteId,
                sysId: contactId,
                tableId: "contact",
                fieldList: [],
            }).unwrap();

            const contactServiceId = contact.edtec365_service;
            if (contactServiceId) {
                return contactServiceId;
            }

            const programId = contact.mshied_currentprogramid;
            const program = await getRecord({
                userId: userId,
                portalId: siteId,
                sysId: programId,
                tableId: "mshied_program",
                fieldList: [],
            }).unwrap();

            const programServiceId = program.edtec365_service;
            if (programServiceId) {
                return programServiceId;
            } else {
                throw new Error("Service not found in both contact or program.");
            }
        } catch (error) {
            throw new Error("Service not found in both contact or program.");
        }
    };

    return { serviceId, error };
}
